import { createContext, useContext } from 'react';
import type { AoeTemplate } from '@roll1/shared';

/**
 * The shared area templates of the map on screen, for a canvas that does not get them as a prop (the phone's single-layer
 * canvas). The desktop CanvasArea receives the same map as a prop.
 */
const AoeTemplatesViewContext = createContext<ReadonlyMap<string, AoeTemplate> | null>(null);

export const AoeTemplatesViewProvider = AoeTemplatesViewContext.Provider;

export function useAoeTemplatesView(): ReadonlyMap<string, AoeTemplate> | null {
  return useContext(AoeTemplatesViewContext);
}
